// extracted by css-extract-rspack-plugin
export default {"buttonLoader":"GooglePay__button-loader--6BL4u","pulse":"GooglePay__pulse--2JtwJ"};